import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";

export default function EditProductsModal({
  show,
  handleClose,
  initialData = {},
  categories = [], // ✅ tree (parent + children)
  onSave,
  saving = false,
}) {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [order, setOrder] = useState(""); // ✅ Эрэмбэ

  const [catId, setCatId] = useState("");
  const [subCatId, setSubCatId] = useState("");
  const [subCategories, setSubCategories] = useState([]);

  useEffect(() => {
    setName(initialData.name || "");
    setPrice(
      initialData.price !== undefined && initialData.price !== null
        ? String(initialData.price)
        : ""
    );
    setQuantity(
      initialData.quantity !== undefined && initialData.quantity !== null
        ? String(initialData.quantity)
        : ""
    );
    setOrder(
      initialData.order !== undefined && initialData.order !== null
        ? String(initialData.order)
        : ""
    );

    // ✅ initialData.categoryId-г AddProductModal style-ээр тааруулах
    const currentCategoryId =
      initialData.categoryId !== undefined && initialData.categoryId !== null
        ? Number(initialData.categoryId)
        : null;

    if (!currentCategoryId) {
      setCatId("");
      setSubCatId("");
      setSubCategories([]);
      return;
    }

    // 1) parent дээр байгаа эсэх
    const parentHit = categories.find((c) => Number(c.id) === currentCategoryId);
    if (parentHit) {
      setCatId(String(parentHit.id));
      setSubCatId("");
      setSubCategories(parentHit.children || []);
      return;
    }

    // 2) child дээрээс parent-г олох
    let foundParent = null;
    for (const p of categories) {
      const hit = (p.children || []).find((ch) => Number(ch.id) === currentCategoryId);
      if (hit) {
        foundParent = p;
        break;
      }
    }

    if (foundParent) {
      setCatId(String(foundParent.id));
      setSubCategories(foundParent.children || []);
      setSubCatId(String(currentCategoryId));
    } else {
      setCatId("");
      setSubCatId("");
      setSubCategories([]);
    }
  }, [initialData, categories]);

  const handleSave = () => {
    const categoryIdToUse = subCatId || catId;

    onSave({
      name,
      price: price === "" ? undefined : parseFloat(price),
      quantity: quantity === "" ? undefined : parseInt(quantity, 10),
      order: order === "" ? undefined : parseInt(order, 10), // ✅ order update
      categoryId: categoryIdToUse ? Number(categoryIdToUse) : undefined,
    });
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Бараа засах</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="g-3">
          {/* CATEGORY */}
          <Col xs={12} md={6}>
            <Form.Label>Ангилал</Form.Label>
            <Form.Select
              value={catId}
              onChange={(e) => {
                const selectedId = Number(e.target.value);
                setCatId(String(selectedId));
                setSubCatId("");
                const parent = categories.find((el) => Number(el.id) === selectedId);
                setSubCategories(parent?.children || []);
              }}
              disabled={saving}
            >
              <option value="">Сонгох...</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </Form.Select>
          </Col>

          {/* SUB CATEGORY */}
          <Col xs={12} md={6}>
            <Form.Label>Дэд ангилал</Form.Label>
            <Form.Select
              value={subCatId}
              onChange={(e) => setSubCatId(e.target.value)}
              disabled={saving || !catId || subCategories.length === 0}
            >
              <option value="">Сонгох...</option>
              {subCategories.map((sc) => (
                <option key={sc.id} value={sc.id}>
                  {sc.name}
                </option>
              ))}
            </Form.Select>
          </Col>

          <Col xs={12}>
            <Form.Label>Барааны нэр</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={saving}
            />
          </Col>

          <Col xs={12} md={4}>
            <Form.Label>Үнэ</Form.Label>
            <Form.Control
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              disabled={saving}
            />
          </Col>

          <Col xs={12} md={4}>
            <Form.Label>Үлдэгдэл</Form.Label>
            <Form.Control
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              disabled={saving}
            />
          </Col>

          <Col xs={12} md={4}>
            <Form.Label>Эрэмбэ</Form.Label>
            <Form.Control
              type="number"
              value={order}
              onChange={(e) => setOrder(e.target.value)}
              disabled={saving}
            />
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={saving}>
          Болих
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={saving}>
          {saving ? "Хадгалж байна..." : "Хадгалах"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
